export default __webpack_public_path__ + "static/media/4.b631b75d.svg";